import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'numberToWords',
})
export class NumberToWordsPipe implements PipeTransform {
  private ones: string[] = ['', 'un', 'deux', 'trois', 'quatre', 'cinq', 'six', 'sept', 'huit', 'neuf'];
  private teens: string[] = ['dix', 'onze', 'douze', 'treize', 'quatorze', 'quinze', 'seize', 'dix-sept', 'dix-huit', 'dix-neuf'];
  private tens: string[] = ['', '', 'vingt', 'trente', 'quarante', 'cinquante', 'soixante', 'soixante-dix', 'quatre-vingt', 'quatre-vingt-dix'];
  private thousands: string[] = ['', 'mille', 'million', 'milliard'];

  transform(value: number): string {
    if (value === 0) return 'zéro';
    return this.convertNumberToWords(value);
  }

  private convertNumberToWords(num: number): string {
    if (num < 10) return this.ones[num];
    if (num < 20) return this.teens[num - 10];
    if (num < 100) return this.convertTens(num);
    if (num < 1000) return this.convertHundreds(num);
    return this.convertThousands(num);
  }

  private convertTens(num: number): string {
    if (num < 20) return this.teens[num - 10];
    const ten = Math.floor(num / 10);
    const remainder = num % 10;
    let word = this.tens[ten];
    if (ten === 7 || ten === 9) {
      word += '-' + this.teens[remainder];
    } else if (remainder) {
      word += '-' + this.ones[remainder];
    }
    return word;
  }

  private convertHundreds(num: number): string {
    const hundred = Math.floor(num / 100);
    const remainder = num % 100;
    let word = '';
    if (hundred > 1) {
      word = this.ones[hundred] + ' cent';
    } else {
      word = 'cent';
    }
    if (remainder) {
      word += ' ' + this.convertTens(remainder);
    }
    return word;
  }

  private convertThousands(num: number): string {
    const thousand = Math.floor(num / 1000);
    const remainder = num % 1000;
    let word = this.convertHundreds(thousand) + ' mille';
    if (remainder) {
      word += ' ' + this.convertHundreds(remainder);
    }
    return word;
  }
}
